var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ 'sidebar-wrapper': _vm.$vuetify.breakpoint.mdAndUp }},[_c('about-me')],1),_c('div',{class:{ 'content-wrapper': _vm.$vuetify.breakpoint.mdAndUp }},[_c('experience'),_c('skills'),_c('projects'),_c('blog-posts')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }